/* =============================================================================
   千丸屋: カート追従バー (sm-buybar)
   方針: 岩手県産EC で実証済みの「テーマ純正 variant picker を再利用する」方式を
        Dawn 15.4 へ移植。追従バー内の <select> は本物の variant-radios /
        variant-selects の input を操作して change を発火させるだけ。
        数量セレクターも同様に、本体の quantity input(min/max/step)を
        ミラー操作するだけで、加算ロジックや検証はテーマ側に揃える。
        価格・在庫・sold out 表示の更新ロジックは一切自作しない。
   表示制御: IntersectionObserver で本体のカートボタンが画面外に出たら表示。
   対象外: 本体ボタンが初期状態で disabled の商品(sold out / plus-yuba の
          「お問い合わせください」)にはバー自体を生成しない。
   レイアウト: PC=中央一群(商品名+価格/数量/選択/ボタン)、SP=2段構成。
   作成: 2026-07-02 / 改訂2: PCの間延び解消・SP2段化・数量セレクター追加(嶋崎指摘)
   ============================================================================= */
(function () {
  'use strict';

  function init() {
    var section = document.querySelector('section[id^="MainProduct-"]');
    if (!section) return;
    var sectionId = section.getAttribute('data-section');

    var form = section.querySelector('product-form form[data-type="add-to-cart-form"]');
    var realBtn = section.querySelector('.product-form__submit');
    if (!form || !realBtn) return;
    if (realBtn.disabled) return;
    if (document.querySelector('.sm-buybar')) return;

    var titleEl = section.querySelector('.product__title h1');
    var titleText = (titleEl ? titleEl.textContent : document.title).trim();

    // --- 追従バー DOM ---
    var bar = document.createElement('div');
    bar.className = 'sm-buybar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="sm-buybar__inner">' +
      '  <div class="sm-buybar__info">' +
      '    <span class="sm-buybar__title"></span>' +
      '    <span class="sm-buybar__price" data-sm-price></span>' +
      '  </div>' +
      '  <div class="sm-buybar__controls">' +
      '    <div class="sm-buybar__qty" data-sm-qty>' +
      '      <button type="button" class="sm-buybar__qty-btn" data-sm-qty-minus aria-label="数量を減らす">−</button>' +
      '      <input class="sm-buybar__qty-input" type="number" inputmode="numeric" value="1" aria-label="数量">' +
      '      <button type="button" class="sm-buybar__qty-btn" data-sm-qty-plus aria-label="数量を増やす">＋</button>' +
      '    </div>' +
      '    <div class="sm-buybar__variants" data-sm-variants></div>' +
      '    <button type="button" class="sm-buybar__add" data-sm-add>カートに追加</button>' +
      '  </div>' +
      '</div>';
    bar.querySelector('.sm-buybar__title').textContent = titleText;
    document.body.appendChild(bar);
    document.body.classList.add('sm-buybar-active');

    // 末尾コンテンツがバーに隠れないよう、バーの実高さぶん body 下余白を確保
    // (バリアント有無・PC/SP で高さが変わるため計測して設定する)
    // 併せて:
    //  - テーマプレビュー時は Shopify の Draft ツールバー(#PBarNextFrameWrapper,
    //    fixed bottom, 高さ約68px)がバーを覆い隠すため、その高さぶんバーを持ち上げる
    //  - Shopify Inbox のチャットボタン(#ShopifyChat, fixed bottom:80px)が
    //    バーに重ならないよう、バーの上へ退避させる
    function updateBodyPad() {
      var pbar = document.getElementById('PBarNextFrameWrapper');
      var lift = (pbar && pbar.offsetHeight) ? pbar.offsetHeight : 0;
      bar.style.bottom = lift ? lift + 'px' : '';
      var h = bar.offsetHeight + lift;
      document.body.style.paddingBottom = h + 'px';
      var chat = document.getElementById('ShopifyChat');
      if (chat) chat.style.setProperty('bottom', (h + 12) + 'px', 'important');
    }
    window.addEventListener('resize', updateBodyPad, { passive: true });
    // チャット/プレビューバーはアプリ・Shopify の script が遅れてマウントするため、
    // 初期化後にも数回追従させる
    [1500, 4000, 8000].forEach(function (t) { setTimeout(updateBodyPad, t); });

    var priceTarget = bar.querySelector('[data-sm-price]');
    var variantsWrap = bar.querySelector('[data-sm-variants]');
    var barAdd = bar.querySelector('[data-sm-add]');
    var qtyWrap = bar.querySelector('[data-sm-qty]');
    var qtyInput = bar.querySelector('.sm-buybar__qty-input');

    function currentRealBtn() {
      return section.querySelector('.product-form__submit');
    }

    // -------------------------------------------------------------------------
    // 価格の同期: 本体の #price-<sectionId> を読む(セール中はセール価格を優先)
    // -------------------------------------------------------------------------
    function readPrice() {
      var box = document.getElementById('price-' + sectionId);
      if (!box) return '';
      var el =
        box.querySelector('.price--on-sale .price__sale .price-item--sale') ||
        box.querySelector('.price__regular .price-item--regular') ||
        box.querySelector('.price-item');
      if (!el) return '';
      var clone = el.cloneNode(true);
      clone.querySelectorAll('.visually-hidden').forEach(function (n) { n.remove(); });
      return clone.textContent.replace(/\s+/g, ' ').trim();
    }
    function syncPrice() {
      var p = readPrice();
      if (p) priceTarget.textContent = p;
    }
    // テーマの価格更新は fetch 後の再描画で非同期。数回ポーリングして確実に拾う
    function syncPriceSoon() {
      [120, 350, 700, 1200].forEach(function (t) { setTimeout(syncAll, t); });
    }

    // -------------------------------------------------------------------------
    // カートボタン状態の同期(variant 切替で sold out になった場合など)
    // -------------------------------------------------------------------------
    function syncAddState() {
      var real = currentRealBtn();
      var disabled = !real || real.disabled;
      barAdd.disabled = disabled;
      if (real) {
        var span = real.querySelector('span');
        var label = (span ? span.textContent : real.textContent).trim();
        if (label) barAdd.textContent = label;
      }
    }

    // -------------------------------------------------------------------------
    // 数量の同期: 本体の quantity input(min/max/step 付き)をミラー操作する
    // -------------------------------------------------------------------------
    function realQtyInput() {
      return section.querySelector('quantity-input input.quantity__input');
    }

    function qtyRule() {
      var real = realQtyInput();
      if (!real) return { min: 1, max: Infinity, step: 1 };
      var min = parseInt(real.getAttribute('min'), 10);
      var max = parseInt(real.getAttribute('max'), 10);
      var step = parseInt(real.getAttribute('step'), 10);
      return {
        min: isNaN(min) ? 1 : min,
        max: isNaN(max) ? Infinity : max,
        step: isNaN(step) || step < 1 ? 1 : step,
      };
    }

    function clampQty(v) {
      var r = qtyRule();
      if (isNaN(v)) v = r.min;
      v = Math.round(v / r.step) * r.step;
      if (v < r.min) v = r.min;
      if (v > r.max) v = r.max;
      return v;
    }

    function syncQtyFromReal() {
      var real = realQtyInput();
      if (!real) { qtyWrap.style.display = 'none'; return; }
      qtyWrap.style.display = '';
      if (qtyInput.value !== real.value) qtyInput.value = real.value;
    }

    function setQty(v) {
      var real = realQtyInput();
      var next = clampQty(v);
      qtyInput.value = next;
      if (real && real.value !== String(next)) {
        real.value = next;
        real.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (!realQtyInput()) qtyWrap.style.display = 'none';
    else qtyInput.value = realQtyInput().value || '1';

    bar.querySelector('[data-sm-qty-minus]').addEventListener('click', function () {
      setQty((parseInt(qtyInput.value, 10) || 1) - qtyRule().step);
    });
    bar.querySelector('[data-sm-qty-plus]').addEventListener('click', function () {
      setQty((parseInt(qtyInput.value, 10) || 1) + qtyRule().step);
    });
    qtyInput.addEventListener('change', function () {
      setQty(parseInt(qtyInput.value, 10));
    });

    function syncAll() {
      syncPrice();
      syncAddState();
      syncQtyFromReal();
      updateBodyPad();
    }

    // -------------------------------------------------------------------------
    // バリエーションのミラー: variant-radios(radio 群) / variant-selects(select)
    // の各オプションを <select> として複製。バー側の変更は本物へ流し込むだけ
    // -------------------------------------------------------------------------
    var mirrors = []; // { select, getRealValue }

    function buildMirrors() {
      variantsWrap.innerHTML = '';
      mirrors = [];
      var picker = section.querySelector('variant-radios, variant-selects');
      if (!picker) return; // 単一バリアント商品 → ミラー不要

      var groups = picker.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown');
      groups.forEach(function (groupEl) {
        var realSelect = groupEl.querySelector('select.select__select');
        var radios = groupEl.querySelectorAll('input[type="radio"]');

        var values; // [{ value, label, soldout }]
        if (realSelect) {
          values = Array.prototype.map.call(realSelect.options, function (o) {
            return { value: o.value, label: o.textContent.trim(), soldout: false };
          });
        } else if (radios.length) {
          values = Array.prototype.map.call(radios, function (r) {
            var lab = groupEl.querySelector('label[for="' + r.id + '"]');
            var label = r.value;
            if (lab) {
              // 構造化セル(名前+実価格)なら「名前 ¥価格」で表示
              var nameSpan = lab.querySelector('.sm-opt__name');
              var priceSpan = lab.querySelector('.sm-opt__price');
              if (nameSpan) {
                label = nameSpan.textContent.trim() + (priceSpan ? ' ' + priceSpan.textContent.trim() : '');
              } else {
                var labClone = lab.cloneNode(true);
                labClone.querySelectorAll('.visually-hidden').forEach(function (n) { n.remove(); });
                label = labClone.textContent.trim();
              }
            }
            return { value: r.value, label: label, soldout: r.classList.contains('disabled') };
          });
        } else {
          return;
        }

        var sel = document.createElement('select');
        sel.className = 'sm-buybar__select';
        sel.setAttribute('aria-label', titleText + ' の選択肢');
        values.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.value;
          o.textContent = v.soldout ? v.label + '(在庫切れ)' : v.label;
          sel.appendChild(o);
        });
        variantsWrap.appendChild(sel);

        function getRealValue() {
          if (realSelect) return realSelect.value;
          var checked = groupEl.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : null;
        }
        function setReal(val) {
          if (realSelect) {
            realSelect.value = val;
            realSelect.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          var target = null;
          radios.forEach(function (r) { if (r.value === val) target = r; });
          if (target && !target.checked) {
            target.checked = true;
            target.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        var cur = getRealValue();
        if (cur != null) sel.value = cur;
        sel.addEventListener('change', function () {
          setReal(sel.value);
          syncPriceSoon();
        });

        mirrors.push({ select: sel, getRealValue: getRealValue });
      });
    }

    // 本体 → バー(ユーザーが本体側で選択を変えた場合)
    function reflectFromReal() {
      mirrors.forEach(function (m) {
        var v = m.getRealValue();
        if (v != null && m.select.value !== v) m.select.value = v;
      });
      syncAll();
    }

    buildMirrors();
    syncAll();
    updateBodyPad();

    section.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('variant-radios input[type="radio"]') || t.matches('variant-selects select')) {
        reflectFromReal();
        syncPriceSoon();
      }
      if (t.matches('quantity-input input.quantity__input')) {
        syncQtyFromReal();
      }
    }, true);

    // 価格エリアの再描画を監視して常に同期(最も確実)
    var priceBox = document.getElementById('price-' + sectionId);
    if (priceBox && 'MutationObserver' in window) {
      var priceTimer = null;
      new MutationObserver(function () {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(syncAll, 80);
      }).observe(priceBox, { childList: true, subtree: true, characterData: true });
    }

    // テーマが picker の中身を差し替えた場合に追従して再構築
    var picker = section.querySelector('variant-radios, variant-selects');
    if (picker && 'MutationObserver' in window) {
      var rebuildTimer = null;
      new MutationObserver(function (muts) {
        var external = muts.some(function (m) {
          return !(m.target && m.target.closest && m.target.closest('.sm-buybar'));
        });
        if (!external) return;
        clearTimeout(rebuildTimer);
        rebuildTimer = setTimeout(function () {
          var selected = mirrors.map(function (m) { return m.getRealValue(); });
          buildMirrors();
          mirrors.forEach(function (m, i) {
            if (selected[i] != null) m.select.value = m.getRealValue() || selected[i];
          });
          syncAll();
        }, 120);
      }).observe(picker, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });
    }

    // -------------------------------------------------------------------------
    // 追加ボタン: 本物のカートボタンを click(テーマの Ajax カートをそのまま使う)
    //            数量は本体 input を同期済みなので、そのままフォーム送信される
    // -------------------------------------------------------------------------
    barAdd.addEventListener('click', function () {
      var real = currentRealBtn();
      if (!real || real.disabled) return;
      real.click();
    });

    // -------------------------------------------------------------------------
    // 表示制御: 本体カートボタンが画面外に出たらバー表示
    // -------------------------------------------------------------------------
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
        syncAddState();
      }, { threshold: 0 });
      io.observe(realBtn);
    } else {
      window.addEventListener('scroll', function () {
        var real = currentRealBtn();
        if (!real) return;
        var r = real.getBoundingClientRect();
        var visible = r.top < window.innerHeight && r.bottom > 0;
        bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
